import React from 'react';
import { CodeSamples } from '..';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from '../samples/CodeSample';
import CodeSampleTabs from './CodeSampleTabs';
import Paragraph from 'antd/lib/typography/Paragraph';

const DEFAULT_MERGE_TAGS = {
  comment: 'Build something great :)',
  commentId: 'commentId-1234-abcd-wxyz'
};

const BackendCodeSampleTabs: React.FC<Partial<BuildCodeParams>> = ({
  environment,
  notification,
  user,
  mergeTags
}) => {
  const backendCodeSamples = CodeSamples.filter(
    (sample) => sample.codeType === CodeType.BACKEND
  );

  return (
    <>
      <CodeSampleTabs
        environment={environment}
        notification={notification}
        user={user}
        codeSamples={backendCodeSamples}
        mergeTags={mergeTags ?? DEFAULT_MERGE_TAGS}
      />
      <Paragraph>
        For more information on sending notifications please see our{' '}
        <a
          href="https://docs.notificationapi.com/reference/server"
          target="_blank"
          rel="noreferrer"
        >
          server documentation.
        </a>
      </Paragraph>
    </>
  );
};

export default BackendCodeSampleTabs;
